const styles = () => ({
  noData: {
    margin: '10px 0',
    color: 'red'
  }
});

export default styles;
